import React from 'react';
import PropTypes from 'prop-types';

export default function TerminologyIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148697' />
      <g fill={fill} data-name='Grupo 151211'>
        <path d='M13.728 2.313v3.958h3.958Z' data-name='Caminho 11911' />
        <path d='M12.13 10.411 8.542 6.823 8.2 6.481v3.93h3.93Z' data-name='Caminho 11912' />
        <path
          d='M10.888 11.308H7.243V5.983H3v12.416h9.568v-7.091h-1.68Z'
          data-name='Caminho 11913'
        />
        <path
          d='M12.674 7.325V2H8.403v3.417l.4.4 3.958 3.958.627.626v4.044h4.613V7.326Z'
          data-name='Caminho 11914'
        />
      </g>
    </svg>
  );
}

TerminologyIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

TerminologyIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
